// extracted by mini-css-extract-plugin
module.exports = {"logo_img":"styles_logo_img__3EFQ6","sticky":"styles_sticky__S2PA9"};